import { render, staticRenderFns } from "./PersonnelRequirements.vue?vue&type=template&id=a1f06f54&scoped=true"
import script from "./PersonnelRequirements.vue?vue&type=script&lang=js"
export * from "./PersonnelRequirements.vue?vue&type=script&lang=js"
import style0 from "./PersonnelRequirements.vue?vue&type=style&index=0&id=a1f06f54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f06f54",
  null
  
)

export default component.exports